/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_EmptyInputs */

const en_admin_tickets_empty = /** @type {(inputs: Admin_Tickets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tickets`)
};

const zh_admin_tickets_empty = /** @type {(inputs: Admin_Tickets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无工单`)
};

/**
* | output |
* | --- |
* | "No tickets" |
*
* @param {Admin_Tickets_EmptyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_empty = /** @type {((inputs?: Admin_Tickets_EmptyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_EmptyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_empty(inputs)
	return zh_admin_tickets_empty(inputs)
});
export { admin_tickets_empty as "admin.tickets.empty" }